var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6141 11L11.7141 6.1C11.3275 5.7134 11.3275 5.0866 11.7141 4.7C12.1007 4.3134 12.7275 4.3134 13.1141 4.7L19.707 11.2929C20.0975 11.6834 20.0975 12.3166 19.707 12.7071L13.1141 19.3C12.7275 19.6866 12.1007 19.6866 11.7141 19.3C11.3275 18.9134 11.3275 18.2866 11.7141 17.9L16.6141 13H5.41406C4.86178 13 4.41406 12.5523 4.41406 12C4.41406 11.4477 4.86178 11 5.41406 11H16.6141Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b9766590791c7db803fc44670b82899e.svg";
export { ForwardRef as ReactComponent };